module.exports = __webpack_public_path__ + "static/media/finalizing.83c8ac0e.gif";